// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32cdb93b","885":"aea38910"}[chunkId] + ".chunk.js";
};